import { render, staticRenderFns } from "./ConsumiGestioneBC.vue?vue&type=template&id=513e007d&scoped=true"
import script from "./ConsumiGestioneBC.vue?vue&type=script&lang=ts"
export * from "./ConsumiGestioneBC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e007d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513e007d')) {
      api.createRecord('513e007d', component.options)
    } else {
      api.reload('513e007d', component.options)
    }
    module.hot.accept("./ConsumiGestioneBC.vue?vue&type=template&id=513e007d&scoped=true", function () {
      api.rerender('513e007d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ConsumiGestioneBC.vue"
export default component.exports